import { Component, Input, OnChanges, OnDestroy, OnInit } from '@angular/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { ChartShowModes } from '@site-mate/dashpivot-shared-library';

import { AnalyticsService } from 'app/analytics/analytics.service';
import { ChartColorScheme } from 'app/shared/model/charts/chart-color-scheme.model';
import { ChartSettings } from 'app/shared/model/charts/chart-settings.model';
import { ChartThumbnailDataSettings } from 'app/shared/model/charts/chart-thumbnail-data-settings.model';
import { ChartData } from 'app/shared/model/charts/ratio/chart-data.model';
import { DateRangeFormatters } from 'app/shared/model/charts/ratio/date-range-formatters.model';
import { ChartUtilsService } from 'app/shared/service/chart-utils.service';
import { ErrorHandler } from 'app/shared/service/error-handler.service';
import { RatioChartDataParserService } from 'app/shared/service/ratio-chart-data-parser.service';

@Component({
  selector: 'cc-ratio-chart-thumbnail',
  templateUrl: './ratio-chart-thumbnail.component.html',
  styleUrls: ['./ratio-chart-thumbnail.component.scss'],
})
export class RatioChartThumbnailComponent implements OnChanges, OnDestroy, OnInit {
  private readonly destroy$ = new Subject<void>();
  readonly chartShowModes = ChartShowModes;
  readonly chartColorScheme = ChartColorScheme;
  readonly dateRangeFormatters = DateRangeFormatters;

  @Input() chart: ChartSettings;
  data: ChartData[] = [];
  loading = true;
  xLabel = '';

  constructor(
    private readonly analyticsService: AnalyticsService,
    private readonly chartUtilsService: ChartUtilsService,
    private readonly errorHandler: ErrorHandler,
    private readonly ratioChartDataParserService: RatioChartDataParserService,
  ) {}

  ngOnInit() {
    this.loadData();
  }

  ngOnChanges() {
    this.loadData();
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  private loadData() {
    if (this.chart.templateId) {
      this.analyticsService
        .listTemplateForms(this.chart.templateId, this.chartUtilsService.getURLParams(this.chart))
        .pipe(takeUntil(this.destroy$))
        .subscribe((forms) => {
          const { data } = this.ratioChartDataParserService.parse(forms, this.chart);
          this.data = data;
          this.xLabel = ChartThumbnailDataSettings[this.chart.timeframe].xAxisLabel;
          this.loading = false;
        }, this.errorHandler.handle.bind(this.errorHandler));
    }
  }
}
